import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Announcement } from '@breathelife/types';

export type PublishedAnnouncementsState = {
  announcements: Announcement[];
  isFetching: boolean;
};

const initialState: PublishedAnnouncementsState = {
  announcements: [],
  isFetching: false,
};

export const publishedAnnouncementsSlice = createSlice({
  name: 'publishedAnnouncements',
  initialState,
  reducers: {
    setAnnouncements: (state, action: PayloadAction<{ announcements: Announcement[] }>) => {
      state.announcements = action.payload.announcements;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
  },
});
